function SublinkTargetPath () {}

SublinkTargetPath.prototype.init = function () {
	const subLinks = document.querySelectorAll( '[data-sub-link]' );
	subLinks.forEach(
		function ( e ) {
			e.addEventListener( 'click', this.addTargetPath );
		}.bind( this ),
	);
};

SublinkTargetPath.prototype.addTargetPath = function ( e ) {
	e.preventDefault();

	// Send event to RTA
	if ( 'RTA' in window ) {
		window.RTA.pageEvent( { paywall_click: 1 } );
		window.RTA.defer( 'paywall' );
	}

	const url = new URL( e.srcElement.getAttribute( 'href' ) );

	url.searchParams.set( '_target_path', encodeURI( `${window.location.origin}${window.location.pathname}` ) ); // phpcs:ignore WordPressVIPMinimum.JS.Window.location

	window.location.href = url.href;
};

const subLinkTargetPath = new SublinkTargetPath();
subLinkTargetPath.init();
